import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useRouteError, useNavigate } from 'react-router-dom';
import Home from '@mui/icons-material/Home';
import ErrorOutline from '@mui/icons-material/ErrorOutline';

const ErrorPage: React.FC = () => {
  const error = useRouteError() as any;
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          py: 4,
        }}
      >
        <ErrorOutline sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />

        <Typography variant="h2" component="h1" gutterBottom>
          Oops! Something went wrong
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
          {error?.statusText || error?.message || 'An unexpected error occurred'}
        </Typography>

        {error?.status && (
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            Error {error.status}: {error.statusText}
          </Typography>
        )}

        <Button variant="contained" startIcon={<Home />} onClick={() => navigate('/')} size="large">
          Go Home
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorPage;
